import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { FormLabel, FormGroup } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CheckBox from "../Forms/CheckboxWithLabel";

import { styles } from "./styles";

const RiskLevelFilter = (props) => {
  const { classes } = props;
  const { t } = useTranslation();
  const [checked, setChecked] = useState({
    high: false,
    medium: false,
    low: false,
  });

  const buildCheckBox = (label, value, onChange) => {
    return (
      <div className={classes.checkBoxContainer}>
        <CheckBox label={label} onChange={onChange} value={value} />
      </div>
    );
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t('By Risk Level')}</FormLabel>
      <FormGroup>
        {buildCheckBox("High", checked["high"], (e) =>
          setChecked({ ...checked, high: e.target.checked })
        )}
        {buildCheckBox("Medium", checked["medium"], (e) =>
          setChecked({ ...checked, medium: e.target.checked })
        )}
        {buildCheckBox("Low", checked["low"], (e) =>
          setChecked({ ...checked, low: e.target.checked })
        )}
      </FormGroup>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RiskLevelFilter);
